window.BUTLocalization = window.BUTLocalization || class BUTLocalization extends BUTCustomComponent {
  constructor() {
    super();
  }

  async init() {
    if (Shopify.designMode) {
      await this.getSearchResults();
    } else {
      const handleIntersection = async (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        await this.getSearchResults();

        observer.unobserve(this);
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        threshold: 0.25,
      }).observe(this);
    }
  }

  async getSearchResults() {
    BUTHelper.loadScript(
      this.dataset.jsFileId,
      this.dataset.jsFile,
      async function () {
        let key = this.dataset.url.replace(/\s/g, "-").toLowerCase();
        let cached = VAR_LOCALIZATION_CACHE.get(key);

        if (!cached) {
          let markup = await this.fetchResults();
          VAR_LOCALIZATION_CACHE.set(key, markup);

          this.innerHTML = markup;
        } else {
          this.innerHTML = cached;
        }
      }.bind(this)
    );
  }

  async fetchResults() {
    let results = fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const languages = html.querySelector(`#${this.dataset.sectionId}`);
        if (languages && languages.innerHTML.trim().length) {
          //this.innerHTML = languages.innerHTML;

          return languages.innerHTML;
        }
        return "";
      })
      .catch((e) => {
        console.error(e);
        return "";
      });

    return results;
  }

  connectedCallback() {
    this.init();
  }
}

if (!customElements.get("but-localization")) {
  customElements.define("but-localization", window.BUTLocalization);
}